import React, { useContext, useState } from 'react';
import { Col, Container, Form, Image, Row } from 'react-bootstrap';
import ImgLogin from './../assets/img/login.png';
import Titulo from '../elements/Titulo';
import Btn from '../elements/Btn';
import { ContextAlert } from '../context/ContextAlert';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase/firebaseConfig';
import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import Alert from './Alert';
import { dotoniwoofApi } from '../api/dotoniwooApi';
import { useAuth } from '../context/AuthContext';
import { Helmet } from 'react-helmet';



const Login = () => {

    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { handleShow, alert, changeAlert } = useContext(ContextAlert);
    
    const {rol} = useAuth();

    const handleChange = (e) => {
        switch (e.target.name) {
            case 'email':
                setEmail(e.target.value);
                break;
            case 'password':
                setPassword(e.target.value);
                break;
            default:
                break;
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const regularExpresion = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

        if (!regularExpresion.test(email)) {
            handleShow();
            changeAlert(
                {
                    type: "danger",
                    message: "El formato del correo es invalido",
                    header: "Error"
                }
            )
            return;
        }

        if (email === '' || password === '') {
            handleShow();
            changeAlert(
                {
                    type: "danger",
                    message: "Todos los campos deben estar completos",
                    header: "Error"
                }
            )
            return;
        }

        try {

            await signInWithEmailAndPassword(auth, email, password);
            await dotoniwoofApi.get(`/action.php/${rol}`)
            .then(res => {
              let responseApi = res.data;
               localStorage.setItem('menu', JSON.stringify((responseApi.message)));
            })
            .catch(err => {
              console.log(err);
            }).finally(
              () => {
            }
            )
            navigate('/'); 
        } catch (error) {
            console.log(error);
            let message;
            switch (error.code) {
                case 'auth/invalid-password':
                    message = 'Contraseña invalida'
                    break;
                case 'auth/invalid-credential':
                        message = 'Credenciales invalidas'
                        break;
                default:
                    message = "Ocurrio un error en la autenticación"
                    break;
            }


            handleShow();
            changeAlert(
                {
                    type: "danger",
                    message: message,
                    header: "Error"
                }
            )
        }
    }



    return (
        <>
        <Helmet>
        <title>Ingresar</title>
        </Helmet>
        <Container fluid className="d-flex vh-100">
            <Row className="justify-content-center align-self-center w-100 gx-0">
                <Col sm >
                    <Image src={ImgLogin} style={{ width: '100%', height: 'auto' }} />
                </Col >
                <Col sm className=" align-self-center p-4">
                    <Form onSubmit={handleSubmit}>
                        <Titulo>Inicia tu sesión</Titulo>
                        <p>
                            <span>
                                ¿Aún no tienes tu usuario de ingreso?
                            </span>
                        </p>
                        <p>
                            <a href='/registro'>
                                <b>Regístrate aquí</b>
                            </a>
                        </p>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label><strong>Email</strong></Form.Label>
                            <Form.Control
                                name='email'
                                type="text"
                                placeholder="Ingresa tu email"
                                value={email}
                                onChange={handleChange} />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label><strong>Contraseña</strong></Form.Label>
                            <Form.Control
                                name='password'
                                type="password"
                                placeholder="Ingresa tu contraseña"
                                value={password}
                                onChange={handleChange} />
                        </Form.Group>
                        <Btn as="button" type="submit">Iniciar sesión</Btn>
                    </Form></Col>
                <Alert message={alert.message} type={alert.type} header={alert.header}></Alert>
            </Row>
        </Container>
        </>
    );
}

export default Login;